module.exports = __webpack_public_path__ + "img/2-Bleu Outremer - Ultramarinlbau.jpg";